export const bookingFlowPages = new Set([
  "/flight",
  "/baggage",
  "/seats",
  "/extras",
  "/passengers",
  "/payment",
]);
export const bookingFlowAfterFlight = new Set([
  "/baggage",
  "/seats",
  "/extras",
  "/passengers",
  "/payment",
  "/itinerary",
]);
